import React, { useContext, useRef, useEffect } from 'react';
import ReactModal from 'react-modal-resizable-draggable';
import { PDFObject } from 'react-pdfobject';
import { MobXProviderContext } from 'mobx-react';
import '../../../css/Tools.scss';
import useReactModalResizeableDraggable from '../../../hooks/useReactModalResizeableDraggable';
import { register } from '../../../i18n';
import useAccessibilityClick from '../../../hooks/useAccessibilityClick';
import DialogPositionService from '../../services/DialogPositionService';

const t = register('ToolNames');
const t2 = register('AriaLabels');

function ScientificCalculator() {
  const {
    toolbarManager,
    lessonManager
  } = useContext(MobXProviderContext);

  let url = 'https://www.desmos.com/testing/default/scientific';

  if (lessonManager &&
    lessonManager.lessonOptions &&
    lessonManager.lessonOptions.hasTexasTools) {
    url = 'https://www.desmos.com/testing/texas/scientific';
  }

  // CF-4158 If browser doesn't support embedded pdfs (Most mobile browsers) instead of using PDFObject
  // we can use an Iframe.
  const doesBrowserSupportPdfs = PDFObject.supportsPDFs();

  function closeCalc() {
    toolbarManager.setIsScientificCalculatorOpen(false);
    toolbarManager.toggleToolOff('ScientificCalculator');
  }

  useReactModalResizeableDraggable('calculatorTool');

  const closeRef = useRef();
  const headerRef = useRef();
  useAccessibilityClick(closeRef, closeCalc);

  // Focus on the h2 header when the calculator dialog opens
  useEffect(() => {
    // Focus on the header after a short delay to ensure the modal is rendered
    setTimeout(() => {
      if (headerRef.current) {
        headerRef.current.focus();
      }
    }, 100);
  }, []);

  return (
    <div className='calculatorTool'>
      <ReactModal
        initHeight={500}
        initWidth={500}
        isOpen={true} 
        top={DialogPositionService.getDefaultTopPosition()}
        role="dialog">
        <div className='calculatorBody'>
          <div className='tool-header'>
            <h2 
              ref={headerRef}
              className='title-label basic' 
              tabIndex='-1'
              aria-label={t('scientificCalculatorInfo')}>
              {t('scientificCalculatorInfo')}
            </h2>
            <div ref={closeRef} aria-label={t2('closedialog')} className='x-close-button' id='modal-close' role='button' tabIndex='0' />
          </div>
          {doesBrowserSupportPdfs ?
            <PDFObject url={url} />
            : <iframe height='95%' src={url} title='calculator-iframe' width='100%' />}
        </div>
      </ReactModal>
    </div>
  );
}

export default ScientificCalculator;
